import React from "react";
import { useNavigate } from "react-router-dom";
import { FaSeedling } from "react-icons/fa";

const PageNotFound = () => {
    const navigate = useNavigate();
    return (
        <div className="flex flex-col items-center justify-center min-h-[60vh] gap-5">
            <FaSeedling className="text-primary text-6xl opacity-40" />
            <h1 className="text-4xl font-bold text-gray-300">404</h1>
            <p className="text-gray-500 text-center">This page doesn't exist yet.</p>
            <button
                onClick={() => navigate("/dashboard")}
                className="px-5 py-2.5 bg-primary text-white rounded-xl text-sm font-semibold hover:bg-green-600 transition-colors"
            >
                Go to Dashboard
            </button>
        </div>
    );
};

export default PageNotFound;
